<template>
  <div>
    <CCard>
      <CCardHeader>
        {{ $t("List of Members") }}
        <div class="card-header-actions">
          <CButton
            class="mz-button v2-mz-btn mr-2"
            color="primary"
            @click="
              $downloadFile({
                url: MEMBERS_ENDPOINTS.export,
              })
            "
          >
            {{ $t("Export") }}
            <i class="ml-2 mz-icon icon-download-alt color-inherit" />
          </CButton>
          <AddButton
            :to="{
              name: 'Member',
              params: { id: 'new' },
            }"
          />
        </div>
      </CCardHeader>

      <CCardBody>
        <table-component
          :columns="['code_gda', 'code_cpt', 'name', 'email', 'date_creation', 'user_creation', 'actions']"
          :headings="{
            code_gda: $t('GTA Code'),
            code_cpt: $t('Accounting Code'),
            name: $t('Member Name'),
            email: 'Contact',
            date_creation: $t('Date'),
            user_creation: $t('User'),
            actions: ''
          }"
          :url="MEMBERS_ENDPOINTS.list"
          :filter-exclude-columns="['actions']"
          ref="table"
          :table-override-filters="tableOverrideFilters"
        >
          <template slot="code_gda" slot-scope="{ row }">
            <CLink :to="{ name: 'Member', params: { id: row.id_member } }">
              {{ row.code_gda || row.id_member }}
            </CLink>
          </template>

          <template slot="code_cpt" slot-scope="{ row }">
            <CLink :to="{ name: 'Member', params: { id: row.id_member } }">
              {{ row.code_cpt || "" }}
            </CLink>
          </template>

          <template slot="name" slot-scope="{ row }">
            {{ row.name }}
          </template>

          <template slot="email" slot-scope="{ row }">
            <CLink :to="{ name: 'Member', params: { id: row.id_member } }">
              {{ row.email || "" }}
            </CLink>
          </template>

          <template slot="date_creation" slot-scope="{ row }">
            <div class="w-100 text-right">
              {{ row.date_creation }}
            </div>
          </template>

          <template slot="user_creation" slot-scope="{ row }">
            {{ row.user_creation }}
          </template>

          <template slot="actions" slot-scope="{ row }">
            <CButton
              @click="() => deleteMember(row)"
              color="danger"
              variant="outline"
              v-c-tooltip="'Delete member'"
            >
              <i class="fa fa-trash-o" />
            </CButton>
          </template>
        </table-component>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import AddButton from "@/components/AddButton";

import { MEMBERS_ENDPOINTS, MemberService } from "@/services/members";

export default {
  name: "Members",
  components: { AddButton },
  data() {
    return {
      MEMBERS_ENDPOINTS,
    };
  },
  computed: {
    tableOverrideFilters() {
      return {
        columns: {
          options: [
            { label: "Gareat", value: 1 },
            { label: "CCR", value: 0 },
          ],
        },
      };
    },
  },
  methods: {
    async deleteMember(member) {
      if (
        !(await confirm(`Are you sure you want to delete user ${member.email}?`))
      ) {
        return;
      }
      try {
        await MemberService.deleteMember(member.id_member);
      } catch (e) {}
      this.$refs.table.$refs.table.getData();
    },
  },
};
</script>
